/**
 * Geometry shared by the reservation slot and the panel.
 *
 * These mirror the Penpot component "AI Assistant" (page "AI Assistant —
 * Komponente", one component with the variants A–D) and the numbers written out
 * on page "AI Assistant — Bot", board 13, section "03 — Maße & Verhalten".
 *
 * The slot and the panel MUST read the same constants: if the reserved height
 * and the rendered height drift apart, the hero shifts the moment the assistant
 * hydrates.
 */

/** Ask-Bar resting width (appearance A and B). */
export const ASK_BAR_WIDTH = 720;

/**
 * Ask-Bar resting height: header 42 + divider 1 + composer 56 + divider 1 +
 * recording notice 44.
 *
 * This is what AskBarSlot reserves in the document flow, and — because the host
 * caps the resting panel at exactly this height — also what decides whether the
 * recording notice is visible before the first message. At 99 the notice was in
 * the DOM and clipped away, which is not what specs/ai-transparency asks for.
 * See Penpot page "AI Assistant — Komponente", variant A, and board 13 §03.
 */
export const ASK_BAR_HEIGHT = 143;

/** Width once the panel has travelled to the corner (appearance C). */
export const DOCKED_WIDTH = 384;

/** Distance from the viewport's right and bottom edges when docked. */
export const EDGE_GAP = 24;

/** Bubble diameter (appearance D). */
export const BUBBLE_SIZE = 56;

/** The panel never grows past this share of the viewport height. */
export const MAX_PANEL_VH = 0.6;

/** Horizontal page margin to respect on viewports narrower than the Ask-Bar. */
export const PAGE_MARGIN = 24;

/** Travel between appearances, in milliseconds. */
export const TRAVEL_MS = 280;

/** Unfolding the conversation, in milliseconds. */
export const UNFOLD_MS = 220;

/**
 * Distance from the top of the document to the Ask-Bar's resting position.
 *
 * The navigation is `position: fixed`, so `main` starts at the document top and
 * the slot's offset is just its own padding — `pt-28 md:pt-32` on the wrapper in
 * `src/app/page.tsx`. Having it as a number here is what lets the panel paint at
 * the right place from CSS alone, before any measurement has happened.
 */
export const ASK_BAR_TOP = 112;
/** The same offset at Tailwind's `md` breakpoint and above (`md:pt-32`). */
export const ASK_BAR_TOP_MD = 128;
/** Tailwind's `md`. */
export const MD_BREAKPOINT = 768;
